<template>
    <div class="row" v-if="isValid('CanViewContribution')">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">

            <div class="card">
                <div class="BorderBottom ml-2 mr-2 mt-3 mb-3">
                    <span class=" DayHeading">{{ $t('Contribution.Contribution') }}</span>
                </div>
                <div class="card-body">
                    <div class="row" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>{{ $t('Contribution.SearchByName') }}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" name="search" id="search" :placeholder="$t('Contribution.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                            <a v-if="isValid('CanAddContribution')" href="javascript:void(0)" class="btn btn-primary " style="margin-top:27px;" v-on:click="openmodel"><i class="fa fa-plus"></i> {{ $t('Contribution.AddNew') }} </a>
                            <router-link :to="'/HrSetup'">
                                <a href="javascript:void(0)" class="btn btn-outline-danger " style="margin-top:27px;">  <i class="fas fa-arrow-circle-left fa-lg"></i> </a>
                            </router-link>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                            <table class="table table-striped table-hover table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                <thead v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                    <tr>
                                        <th>#</th>
                                        <th>
                                            {{ $t('Contribution.Code') }}
                                        </th>
                                        <th v-if="english=='true'">
                                            {{ $t('Contribution.NameEnglish') }}
                                        </th>
                                        <th v-if="isOtherLang()" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                            {{ $t('Contribution.NameArabic') }}
                                        </th>
                                        <th class="text-center">
                                            {{ $t('Contribution.AmountPercentage') }}
                                        </th>                                      
                                        <th>
                                            {{ $t('Contribution.Status') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                    <tr v-for="(contribution ,index) in contributionList" v-bind:key="contribution.id">
                                        <td v-if="currentPage === 1">
                                            {{index+1}}
                                        </td>
                                        <td v-else>
                                            {{((currentPage*10)-10) +(index+1)}}
                                        </td>

                                        <td  v-if="isValid('CanEditContribution')">
                                            <strong>
                                                <a href="javascript:void(0)" v-on:click="EditContribution(contribution.id)">{{contribution.code}}</a>
                                            </strong>
                                        </td>
                                        <td v-else>
                                            <strong>
                                                {{contribution.code}}
                                            </strong>
                                        </td>
                                        <td v-if="english=='true'">
                                            {{contribution.nameInPayslip}}
                                        </td>
                                        <td v-if="isOtherLang()">
                                            {{contribution.nameInPayslipArabic}}
                                        </td>
                                        <td class="text-center">
                                            {{contribution.amountType==2? currency : ''}} {{parseFloat(contribution.amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}} {{contribution.amountType==1? '%' : ''}}
                                        </td>
                                       
                                        <td>{{contribution.active==true?$t('Active'):$t('De-Active')}}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div class="float-left">
                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                    </div>
                    <div class="float-right">
                        <div class="overflow-auto" v-on:click="GetBrandData()">
                            <b-pagination pills size="lg" v-model="currentPage"
                                          :total-rows="rowCount"
                                          :per-page="10"
                                          first-text="First"
                                          prev-text="Previous"
                                          next-text="Next"
                                          last-text="Last"></b-pagination>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <add-contribution :contribution="newContribution"
                       :show="show"
                       v-if="show"
                       @close="IsSave"
                       :type="type" />

    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>


<script>
    import clickMixin from '@/Mixins/clickMixin'
    export default {
        mixins: [clickMixin],
        data: function () {
            return {
                currency: '',
                searchQuery: '',
                show: false,
                contributionList: [],
                newContribution: {
                    id: '',
                    nameInPayslip: '',
                    nameInPayslipArabic: '',
                    amountType: '',
                    taxPlan: '',
                    code: '',
                    amount: 0,
                    active: true
                },
                type: '',
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                arabic: '',
                english: '',
            }
        },
        watch: {
            search: function () {
                this.GetContributionData();
            }
        },
        methods: {
            IsSave: function () {
                this.show = false;
                this.GetContributionData();
            },

            getPage: function () {
                this.GetContributionData();
            },

            openmodel: function () {
                this.newContribution = {
                    id: '00000000-0000-0000-0000-000000000000',
                    nameInPayslip: '',
                    nameInPayslipArabic: '',
                    amountType: '',
                    taxPlan: '',
                    code: '',
                    amount: 0,
                    active: true
                }
                this.show = !this.show;
                this.type = "Add";
            },

            GetContributionData: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                
                root.$https.get('Payroll/ContributionList?searchTerm=' + this.search + '&pageNumber=' + this.currentPage, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.contributionList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                        root.loading = false;
                    }
                    root.loading = false;
                });
            },

            EditContribution: function (Id) {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Payroll/ContributionDetail?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data) {
                            root.newContribution.id = response.data.id;
                            root.newContribution.nameInPayslip = response.data.nameInPayslip;
                            root.newContribution.nameInPayslipArabic = response.data.nameInPayslipArabic;
                            root.newContribution.amount = response.data.amount;
                            root.newContribution.code = response.data.code;
                            root.newContribution.active = response.data.active;
                            
                            if ((root.$i18n.locale == 'en' || root.isLeftToRight())) {
                                root.newContribution.amountType = response.data.amountType == 1 ? '% of Salary' : 'Fixed';
                                root.newContribution.taxPlan = response.data.taxPlan == 1 ? 'Taxable' : 'Non Taxable';
                            }
                            else {
                                root.newContribution.amountType = response.data.amountType == 1 ? '٪ من الراتب' : 'مثبت';
                                root.newContribution.taxPlan = response.data.taxPlan == 1 ? 'خاضع للضريبة' : 'غير خاضعة للضريبة';
                            }
                            root.show = !root.show;
                            root.type = "Edit"
                        } else {
                            console.log("error: something wrong from db.");
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });

            }
        },

        created: function () {
            this.$emit('input', this.$route.name);
        },

        mounted: function () {
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            this.currency = localStorage.getItem('currency');
            this.GetContributionData();

        }
    }
</script>